import React from "react";
import resume from "../static/media/resume2.png";
import data from "../static/info/data";

export default function Resume() {
  return (
    <>
      <div className="resume-container" id="resume">
        <h1 className="text-4xl font-bold">Resume</h1>
        <div className="resume-wrapper">
          <div className="resume-img">
            <img className="" src={resume} alt="" />
          </div>
          <div
            className="resume-details"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <p className="text-lg sm:text-xl md:text-2xl">
              {data.resumeData.heading}
            </p>
            <a href={data.resumeData.link} target="_blank">
              <button className="download-btn text-sm sm:text-lg">
                Resume<i class="fa fa-download" aria-hidden="true"></i>
              </button>
            </a>
            <br />
            <p className="text-lg sm:text-xl md:text-2xl">
              {data.resumeData.message}
            </p>
            <br />
            <p className="sm:text-lg md:text-xl">
              I am open for the following roles.
            </p>
            <br />
            <div className="roles">
              {data.resumeData.roles.map((item, index) => (
                <button className="text-xs sm:text-sm">{item}</button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
